import { render, staticRenderFns } from "./book-content-welcome.vue?vue&type=template&id=55625d43"
import script from "./book-content-welcome.vue?vue&type=script&lang=js"
export * from "./book-content-welcome.vue?vue&type=script&lang=js"
import style0 from "./book-content-welcome.vue?vue&type=style&index=0&id=55625d43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./book-content-welcome.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports